import React from "react";
import Top from "../../Top";
import Left from "../../Left";
// import { Grid } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import ResidentDetailsTab from "../AddResident/ResidentDetailsTab";
// import { useNavigate } from "react-router-dom";
// import { useEffect } from "react";
import { useParams } from "react-router-dom";
// import EditBuildingTab from "./EditBuildingTab";
import ConfigureBuilding from "./ConfigureBuilding";

function EditBuilding() {
  // const navigate = useNavigate();
  const { bid } = useParams();

  const [open] = React.useState(false);

  const descriptionElementRef = React.useRef(null);
  React.useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);
  return (
    <>
      <Top />
      <Left />

      <ConfigureBuilding name={bid} />
    </>
  );
}

export default EditBuilding;
